<template>
  <div class="app-container">
    <div class="full-height slot-data">
      <!-- 版位維護 -->
      <el-dialog
        custom-class="position-data--edit"
        append-to-body
        :title="!positionForm.id ? '建立版位' : '版位維護'"
        :visible.sync="dialogFormVisible"
        width="60%"
      >
        <el-form ref="positionForm" :model="positionForm" size="mini" @submit.native.prevent>
          <el-form-item prop="companyName" label="產品名稱">
            <el-input v-model="positionForm.project"></el-input>
          </el-form-item>
          <el-form-item prop="advertisementName" label="版位名稱">
            <el-input v-model="positionForm.name"></el-input>
          </el-form-item>
          <el-form-item prop="quantityLimit" label="數量上限">
            <el-input v-model="positionForm.quantityLimit"></el-input>
          </el-form-item>
          <el-form-item prop="status" label="狀態">
            <el-switch
              v-model="positionForm.status"
              active-text="啟用"
              inactive-text="停用"
              inactive-color="#ff4949"
              active-color="#13ce66"
              :active-value="true"
              :inactive-value="false"
            >
            </el-switch>
          </el-form-item>
          <el-form-item prop="type" label="類型">
            <el-radio-group v-model="positionForm.type">
              <el-radio-button :label="1">付費</el-radio-button>
              <el-radio-button :label="2">免費</el-radio-button>
            </el-radio-group>
            <!-- <el-switch v-model="positionForm.type" active-text="免費" inactive-text="付費" inactive-color="#ff4949"
          active-color="#13ce66" :inactive-value="1" :active-value="2">
        </el-switch> -->
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="saveData" type="warning" style="color: #4b4b4b">儲 存</el-button>

          <el-button @click="dialogFormVisible = false">關 閉</el-button>
        </span>
      </el-dialog>
      <el-form :inline="true" class="filter-form" @submit.native.prevent>
        <el-form-item label="查詢">
          <el-input
            v-model="listQuery.qry"
            placeholder="輸入產品/版位名稱"
            @keyup.enter.native="getList"
          />
        </el-form-item>
        <el-form-item label="狀態">
          <el-select v-model="listQuery.status" placeholder="請選擇狀態" @change="getList">
            <el-option
              v-for="item in [
                { key: '', val: '所有' },
                { key: 1, val: '啟用' },
                { key: 0, val: '停用' },
              ]"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-button
          type="primary"
          @click="getList"
          icon="el-icon-search"
          circle
          style="margin-top: 8px; margin-left: 5px"
          :disabled="listLoading"
        ></el-button>
        <el-button
          type="warning"
          @click="editPositionData({ id: null })"
          circle
          icon="el-icon-plus"
          :disabled="listLoading"
        ></el-button>
        <el-button
          style="cursor: pointer"
          type="success"
          :loading="listLoading"
          circle
          icon="el-icon-refresh-left"
          @click="refresh()"
        ></el-button>
      </el-form>

      <div style="position: relative; height: 80%; display: flex; gap: 0 8px">
        <div style="height: 100%">
          <el-table
            ref="positionTable"
            v-loading="listLoading"
            :data="list"
            size="mini"
            border
            fit
            style="width: 100%"
            height="100%"
            :row-class-name="tableRowStatus"
            @sort-change="sortChange"
            highlight-current-row
            current-row-key="id"
            row-key="id"
            @row-click="handleSelectPosition"
          >
            <el-table-column prop="advertisementName" :label="`版位列表 ｜${total}`" width="300">
              <template slot-scope="scope">
                <div style="cursor: pointer">
                  <div style="display: flex; justify-content: space-between; align-items: center">
                    <div style="display: flex; gap: 0 8px">
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          gap: 0 8px;
                          min-width: fit-content;
                        "
                      >
                        <div
                          style="width: 6px; height: 6px; border-radius: 50%"
                          :style="{ background: scope.row.status == 1 ? '#13ce66' : '#ff4949' }"
                        ></div>
                        <div style="letter-spacing: 0.05em; font-weight: 500">
                          {{ scope.row.status == 1 ? '啟用' : '停用' }}
                        </div>
                      </div>
                      <el-tooltip content="進行中數量上限" placement="right">
                        <div style="font-size: 12px; color: #868686; font-weight: 500">
                          {{ handleFormatProgress(scope.row.adCount, scope.row.quantityLimit) }}
                        </div>
                      </el-tooltip>
                    </div>

                    <div>
                      <el-button
                        size="small"
                        circle
                        icon="el-icon-edit"
                        @click.native="editPositionData(scope.row)"
                      ></el-button>
                    </div>
                  </div>
                  <div
                    style="
                      font-weight: 500;
                      font-size: 14px;
                      letter-spacing: 0.05em;
                      padding: 8px 0;
                    "
                  >
                    {{ scope.row.project }} - {{ scope.row.name }}
                  </div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      border-top: 1px solid #ddd;
                      padding-top: 8px;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        width: 100%;
                      "
                    >
                      <div
                        :style="{
                          color: '#fff',
                          backgroundColor: scope.row.type == 1 ? '#fe4949' : '#41b983',
                        }"
                        style="min-width: fit-content; padding: 0 8px; border-radius: 5px"
                      >
                        {{ scope.row.type == 1 ? '付費' : '免費' }}
                      </div>
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        width: 100%;
                      "
                    >
                      <div style="font-weight: 900; font-size: 16px">
                        {{ scope.row.adCount.preparing || 0 }}
                      </div>
                      <div>未開始</div>
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        width: 100%;
                      "
                    >
                      <div style="font-weight: 900; font-size: 16px">
                        {{ scope.row.adCount.processing || 0 }}
                      </div>
                      <div>進行中</div>
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        width: 100%;
                      "
                    >
                      <div style="font-weight: 900; font-size: 16px">
                        {{ scope.row.adCount.isOver || 0 }}
                      </div>
                      <div>已結束</div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="advertisementName"
              :label="`版位列表 ｜${total}`"
              width="300"
              v-if="false"
            >
              <template slot-scope="scope">
                <div style="cursor: pointer; padding: 6px">
                  <div style="display: flex; justify-content: space-between; align-items: center">
                    <div style="display: flex; align-items: center; gap: 0 8px">
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          gap: 0 8px;
                          min-width: fit-content;
                        "
                      >
                        <div
                          style="width: 6px; height: 6px; border-radius: 50%"
                          :style="{ background: scope.row.status == 1 ? '#13ce66' : '#ff4949' }"
                        ></div>
                        <p style="letter-spacing: 0.05em">
                          {{ scope.row.status == 1 ? '啟用' : '停用' }}
                        </p>
                      </div>
                      ｜
                      <span style="font-size: 12px; color: #868686; font-weight: 500"
                        >上限：{{
                          handleFormatProgress(scope.row.adCount, scope.row.quantityLimit)
                        }}</span
                      >
                      <!-- <p>
                                                進行中上限：<span style="font-weight: 500;">{{
                                                    handleFormatProgress(scope.row.adCount, scope.row.quantityLimit)
                                                }}</span>
                                            </p> -->
                    </div>
                    <div>
                      <el-button
                        size="small"
                        circle
                        icon="el-icon-edit"
                        @click.native="editPositionData(scope.row)"
                      ></el-button>
                    </div>
                  </div>
                  <div style="font-weight: 500; font-size: 14px; letter-spacing: 0.05em">
                    {{ scope.row.project }} - {{ scope.row.name }}
                  </div>
                  <!-- <div v-if="scope.row.adCount" style="color:#868686">
                                        未開始：{{ scope.row.adCount.preparing || 0 }}｜
                                        進行中：{{ scope.row.adCount.processing || 0 }}｜
                                        已結束：{{ scope.row.adCount.isOver || 0 }}
                                    </div> -->

                  <!-- <el-progress color="#FED465"
                                        :percentage="handleFormatProgress(scope.row.adCount, scope.row.quantityLimit, true)"
                                        :width="84" :format="() => ''"></el-progress> -->
                  <div style="display: flex; align-items: center; justify-content: space-between">
                    <!-- <p>
                                            進行中上限：<span style="font-weight: 500;">{{ handleFormatProgress(scope.row.adCount, scope.row.quantityLimit) }}</span>
                                        </p> -->
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        width: 100%;
                      "
                    >
                      <el-tag
                        :type="scope.row.type == 1 ? 'danger' : 'success'"
                        style="min-width: fit-content"
                        >{{ scope.row.type == 1 ? '付費' : '免費' }}</el-tag
                      >
                      <!-- <div></div> -->
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        width: 100%;
                      "
                    >
                      <div>3</div>
                      <div>未開始</div>
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        width: 100%;
                      "
                    >
                      <div>3</div>
                      <div>進行中</div>
                    </div>
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        width: 100%;
                      "
                    >
                      <div>3</div>
                      <div>已結束</div>
                    </div>
                    <!-- <div v-if="scope.row.adCount" style="color:#868686">
                                            未開始：{{ scope.row.adCount.preparing || 0 }}｜
                                            <strong style="color:#41b983">進行中：{{ scope.row.adCount.processing || 0 }}</strong>｜
                                            已結束：{{ scope.row.adCount.isOver || 0 }}
                                        </div> -->
                    <!-- <div style="display: flex;align-items: center;gap:0 8px;min-width: fit-content;">
                                            <div style="width:6px;height:6px;border-radius: 50%;"
                                                :style="{ background: scope.row.status == 1 ? '#13ce66' : '#ff4949' }">
                                            </div>
                                            <p style="letter-spacing: 0.05em;">
                                                {{ scope.row.status == 1 ? "啟用" : "停用" }}
                                            </p>
                                        </div> -->
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="height: 100%; flex: 1; max-width: 100%; overflow-x: auto">
          <!-- <div style="display:flex;justify-content: space-between;align-items: center;padding-bottom:8px;">
        <div style="letter-spacing: 0.05em;font-size: 14px;">
          {{ selectedPositionItem.project }} - {{ selectedPositionItem.name }}（{{
            `${selectedPositionItem.processingAdCount || 0}/${selectedPositionItem.quantityLimit}` }}）
        </div>
        <div>
          <el-button size="small" type="warning" @click="handleAddAd">新增廣告</el-button>
        </div>
      </div> -->
          <el-table
            size="mini"
            :data="selectedPosition"
            border
            fit
            height="100%"
            v-loading="contentLoading"
            row-key="id"
          >
            <el-table-column align="center" label="項次" width="50">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="封面圖">
              <template slot-scope="scope">
                <img
                  style="height: 80px; width: 100%; object-fit: contain"
                  v-if="!!scope.row.mapping && !!scope.row.mapping.fileInfo"
                  :src="scope.row.mapping.fileInfo.url"
                />
                <!-- <el-image style="height: 80px;width:100%" v-if="!!scope.row.mapping && !!scope.row.mapping.fileInfo" :src="scope.row.mapping.fileInfo.url
                                    ? scope.row.mapping.fileInfo.url
                                    : 'https://fakeimg.pl/280x160/'
                                    " fit="contain" :preview-src-list="[scope.row.mapping.fileInfo.url]" :lazy="true">
                                </el-image> -->
                <el-image
                  style="height: 80px"
                  v-else
                  :src="'https://fakeimg.pl/280x160/'"
                  fit="contain"
                  :preview-src-list="['https://fakeimg.pl/280x160/']"
                  :lazy="true"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column label="廣告名稱" prop="advertisementName">
              <template slot-scope="{ row }">
                <el-popover placement="right" width="400" trigger="hover">
                  <el-descriptions
                    class="margin-top"
                    title="廣告詳情"
                    :column="1"
                    size="small"
                    border
                  >
                    <el-descriptions-item>
                      <template slot="label">
                        <i class="el-icon-office-building"></i>
                        廣告名稱
                      </template>
                      <div
                        class="copy-container"
                        v-clipboard:copy="row.advertisementName"
                        v-clipboard:success="clipboardSuccess"
                      >
                        <span>
                          {{ row.advertisementName }}
                        </span>
                        <div class="copy-icon" v-show="!!row.advertisementName">
                          <el-icon name="document-copy"> </el-icon>
                        </div>
                      </div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">
                        <i class="el-icon-tickets"></i>
                        排序
                      </template>
                      <div>
                        {{ row.mapping.priority }}
                      </div>
                    </el-descriptions-item>
                    <!-- <el-descriptions-item>
                                            <template slot="label">
                                                <i class="el-icon-mobile-phone"></i>
                                                顯示描述頁
                                            </template>
                                            <div>
                                                {{ row.mapping.showDescriptionPage ? '是' : '否' }}
                                            </div>
                                        </el-descriptions-item> -->
                    <el-descriptions-item>
                      <template slot="label">
                        <i class="el-icon-time"></i>
                        廣告期間
                      </template>
                      <el-tag size="small">
                        {{ `${row.startDate} 至 ${row.endDate}` }}
                      </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item>
                      <template slot="label">
                        <i class="el-icon-location-outline"></i>
                        網址
                      </template>
                      <div
                        class="copy-container"
                        v-clipboard:copy="row.mapping.link"
                        v-clipboard:success="clipboardSuccess"
                      >
                        <a
                          :href="row.mapping.link"
                          @click.capture
                          target="_blank"
                          style="color: #1890ff"
                          >{{ row.mapping.link }}</a
                        >
                        <div class="copy-icon" v-show="!!row.mapping.link">
                          <el-icon name="document-copy"> </el-icon>
                        </div>
                      </div>
                    </el-descriptions-item>
                  </el-descriptions>
                  <div
                    style="cursor:pointer;hover:opacity:75%"
                    slot="reference"
                    @click="toggleExpand(row)"
                  >
                    <span style="text-decoration: underline; font-weight: 500">
                      {{ row.advertisementName }}
                    </span>
                    <br />
                    <span style="color: #939393"> {{ row.startDate }} 至 {{ row.endDate }} </span>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="廣告期間" width="170">
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.row.startDate }} 至 {{ scope.row.endDate }}
                                </span>
                            </template>
                        </el-table-column> -->
            <el-table-column align="center" label="排序" width="60">
              <template slot-scope="scope">
                <p v-if="scope.row.mapping">
                  {{ scope.row.mapping.priority }}
                </p>
              </template>
            </el-table-column>

            <el-table-column align="center" label="曝光數" width="60">
              <template slot-scope="scope">
                <p v-if="scope.row.mapping">
                  {{ (scope.row.mapping.showCount || 0).toLocaleString() }}
                </p>
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              label="狀態"
              width="100"
              fixed="right"
              :filters="[
                { text: '未開始', value: '未開始' },
                { text: '進行中', value: '進行中' },
                { text: '已結束', value: '已結束' },
              ]"
              :filter-method="filterStatus"
            >
              <template slot-scope="scope">
                <el-tag
                  size="small"
                  :type="handleStatus(scope.row.startDate, scope.row.endDate).type"
                >
                  {{ handleStatus(scope.row.startDate, scope.row.endDate).text }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column align="center" label="公司名稱" prop="companyName">
              <template slot-scope="scope">
                <a
                  :href="`/advertisement/customerCompany?q=${scope.row.companyName}`"
                  target="_blank"
                  style="color: #20a0ff"
                >
                  {{ scope.row.companyName }}</a
                >
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="100" fixed="right">
              <template slot-scope="scope">
                <el-button type="danger" size="small" @click="delePositionData(scope.row.mapping)"
                  >刪除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <pagination
        v-show="total > 0"
        layout="prev, pager, next"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { Message } from 'element-ui'
import clipboard from '@/directive/clipboard/index.js' // use clipboard by v-directive

import {
  getSlotsManagement,
  setSlotsManagement,
  getAdvertisementsBySlot,
  deleteAdvertisementSlotMappings,
} from '@/api/advertisement'
import dayjs from 'dayjs'

export default {
  name: 'PositionDataTable',
  directives: {
    clipboard,
  },
  components: { Pagination },
  data() {
    return {
      dialogFormVisible: false,
      listLoading: false,
      contentLoading: false,
      formLoading: false,
      listQuery: {
        qry: '',
        status: '',
        page: 1,
        limit: 20,
        sort: '-id',
      },
      total: 0,
      list: [],
      positionForm: {
        id: null,
        project: '',
        name: '',
        quantityLimit: null,
        status: true,
        type: 2,
      },
      selectedPositionItem: {},
      selectedPosition: [],
    }
  },

  async created() {
    await this.getList()
  },
  methods: {
    handleFormatProgress(adCount, total, isPercentage = false) {
      // const currentAdCount = Object.values(adCount).reduce((acc, val) => acc + val, 0);
      const currentAdCount = adCount.processing || 0
      return isPercentage ? (currentAdCount / total) * 100 : `${currentAdCount}/${total}`
    },
    filterStatus(value, row) {
      const text = this.handleStatus(row.startDate, row.endDate).text
      return text === value
    },
    handleAddAd() {
      this.addAdDialog = true
    },
    handleSelectPosition(row) {
      this.selectedPositionItem = row
      this.contentLoading = true
      const params = {
        id: row.id,
      }
      getAdvertisementsBySlot(params)
        .then(response => {
          this.selectedPosition = response.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.contentLoading = false
        })
    },
    async refresh() {
      this.defaultListQuerySetting()
      await this.getList()
    },
    sortChange(data) {
      const { prop, order } = data
      debugger
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },

    toggleExpand(row) {
      console.log(row)
      let $table = this.$refs.positionTable
      $table.toggleRowExpansion(row)
    },

    tableRowStatus({ row, rowIndex }) {
      return row.hasComplaint ? 'alert-row' : ''
    },
    defaultListQuerySetting() {
      this.listQuery = {
        qry: '',
        status: '',
        page: 1,
        limit: 20,
        sort: '-id',
      }
    },
    async getList() {
      this.listLoading = true
      getSlotsManagement(this.listQuery)
        .then(response => {
          this.list = response.data.data
          this.total = response.data.total
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false

          if (this.list.length > 0) {
            this.$nextTick(() => {
              const firstRow = this.$refs.positionTable.$el.querySelector('tbody tr:first-child')
              if (firstRow) {
                firstRow.click()
              }
            })
          }
        })
    },
    editPositionData(row) {
      this.positionForm = JSON.parse(JSON.stringify(row))
      this.dialogFormVisible = true
    },
    delePositionData(mapping) {
      if (!confirm(`確定要刪除此筆資料?`)) return
      const vm = this
      const params = {
        id: mapping.id,
      }
      vm.listLoading = true
      deleteAdvertisementSlotMappings(params)
        .then(async response => {
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
          await vm.getList()
          vm.listLoading = false
        })
        .catch(e => {
          vm.listLoading = false
        })
    },

    async saveData() {
      const vm = this
      this.$refs['positionForm'].validate(async valid => {
        if (valid) {
          const params = (({ adCount, ...rest }) => rest)(this.positionForm)
          vm.formLoading = true
          await setSlotsManagement(params)
            .then(async response => {
              Message({
                message: '資料處理完成',
                type: 'success',
                duration: 5 * 1000,
              })
              await vm.getList()
              vm.formLoading = false
              vm.dialogFormVisible = false
            })
            .catch(e => {
              vm.formLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editData(row) {
      this.dialogFormVisible = true
      this.positionForm = { ...row }
    },
    handleStatus(startDate, endDate) {
      const today = dayjs()
      if (today.isAfter(startDate) && today.isBefore(endDate)) {
        return {
          text: '進行中',
          type: 'success',
        }
      }
      if (today.isBefore(startDate)) {
        return {
          text: '未開始',
          type: 'warning',
        }
      }
      if (today.isAfter(endDate)) {
        return {
          text: '已結束',
          type: 'info',
        }
      }
      // 添加默認返回值
      return {
        text: '已結束',
        type: 'info',
      }
    },
    clipboardSuccess() {
      this.$message({
        message: '複製成功！',
        type: 'success',
        duration: 1500,
      })
    },
  },
}
</script>
<style lang="scss">
.slot-data {
  .el-dialog__body {
    padding: 15px;
  }

  .el-table .alert-row {
    background: #ffaec8;
  }

  .el-table--enable-row-hover .el-table__body tr.alert-row:hover > td {
    background: #fa95b5;
  }
}

.position-data--edit .el-dialog__body {
  padding-top: 6px !important;
  padding-bottom: 0 !important;
}
</style>

<style scoped>
/* /deep/.position-data .el-form .is-disabled * {
    color: blue !important;
  }
  
  /deep/.el-upload .el-button {
    display: none !important;
  }
  
  /deep/.el-upload-list__item-status-label {
    display: none !important;
  }
  
  /deep/.el-icon-close {
    display: none !important;
  } */

.full-height {
  position: relative;
  height: 100%;
}

.copy-container {
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  gap: 0 0.5rem;
  align-items: center;
}

.copy-container:hover .copy-icon {
  opacity: 1;
  /* 這裡可以調整懸停時的透明度 */
}

.copy-icon {
  opacity: 0;
  /* 初始化為隱藏狀態 */
}

.copy-icon el-icon {
  text-decoration: underline;
  font-weight: 500;
}
</style>
